import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withStyles} from "@material-ui/core/styles";
import {uploadImage} from "../../../AC/upload-image";
import {changeSourceUploader} from "../../../AC/change-source-uploader";
import {
  uploaderSelector,
  picturesSelector,
  shutterStockEnabledSelector
} from "../../../selectors";
import {toggleModal} from "../../../AC/modal";
import PictureBox from "../PictureBox";
import Button from "@material-ui/core/Button";
import LocalIcon from "../../../../../icons/LocalIcon";
import GoogleSearchIcon from "../../../../../icons/GoogleSearchIcon";
import Mediator from "../../../services/Mediator";
import trackEvent from "../../../../../utils/track-event";

const styles = (theme) => ({
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  button: {
    "backgroundColor": `#52abda`,
    "color": `#fff`,
    "fontSize": `12px`,
    "padding": `5px 10px`,
    "&:hover": {
      opacity: `.8`,
      backgroundColor: `#52abda`
    }
  },
  lightButton: {
    border: `1px solid #c4c1c1`,
    fontWeight: `normal`,
    textTransform: `none`,
    color: `#727272`,
    fontSize: `12px`,
    padding: `5px 10px`
  }
});

class Local extends PureComponent {
  static propTypes = {
    uploadImage: PropTypes.func,
    toggleModal: PropTypes.func,
    changeSourceUploader: PropTypes.func,
    uploader: PropTypes.object,
    pictures: PropTypes.object,
    product: PropTypes.object,
    classes: PropTypes.object.isRequired,
    shutterStockEnabled: PropTypes.bool
  };
  state = {
    activeCategory: `images`
  };
  fileInput = React.createRef();
  uploadImage = () => {
    const file = this.fileInput.current.files[0];
    if (file) {
      this.props.uploadImage(file);
    }
  };
  areThereShutterstockPicsOnCanvas = () => {
    const objects = Mediator.getCanvas().getObjects();
    return objects.find((obj) => {
      if (obj.fields) {
        return obj.fields.isShutterstockImage;
      }
      return false;
    });
  };
  componentDidUpdate() {
    if (window && !window.localStorage.getItem(`is-open-clipart`)) {
      window.localStorage.setItem(`is-open-clipart`, true);
      this.setState({
        activeCategory: `cliparts`
      });
    }
  }
  changeSource = (source) => this.props.changeSourceUploader(source);
  render() {
    const {classes, shutterStockEnabled} = this.props;
    return (
      <React.Fragment>
        <div className="local-uploader">
          <p className="local-uploader__requirements">
            <strong>JPG</strong> или <strong>PNG</strong> размером не более{` `}
            <strong>14МБ</strong>.
          </p>
          <div className="local-uploader__content">
            <div className="sources">
              <div className="source">
                <input
                  type="file"
                  name="image[picture]"
                  id="file-input"
                  ref={this.fileInput}
                  accept="image/*"
                  style={{
                    width: `0.1px`,
                    height: `0.1px`,
                    opacity: 0,
                    overflow: `hidden`,
                    position: `absolute`,
                    zIndex: -1
                  }}
                  onChange={this.uploadImage}
                />
                <label htmlFor="file-input">
                  <Button
                    component="span"
                    variant="contained"
                    className={classes.button}
                  >
                    <LocalIcon className={classes.leftIcon} />
                    Загрузить файл
                  </Button>
                </label>
              </div>
              <div className="source">
                <Button
                  variant="outlined"
                  onClick={() => {
                    trackEvent({
                      category: `Editor`,
                      action: `Open Google search`
                    });
                    this.changeSource(`google-search`);
                  }}
                  className={classes.lightButton}
                >
                  Искать в
                  <GoogleSearchIcon
                    style={{width: `55px`, margin: `1px 0 0 5px`}}
                  />
                </Button>
              </div>
              {shutterStockEnabled && !this.areThereShutterstockPicsOnCanvas() && (
                <div className="source">
                  <Button
                    variant="outlined"
                    onClick={() => {
                      trackEvent({
                        category: `Editor`,
                        action: `Open ShutterStock search`
                      });
                      this.changeSource(`shutterstock`);
                    }}
                    className={classes.lightButton}
                  >
                    Искать в ShutterStock
                  </Button>
                </div>
              )}
            </div>
          </div>
          <p className="local-uploader__disclaimer">
            Загружая изображение, вы принимаете{` `}
            <a href="/legal">Пользовательское соглашение</a> и подтверждаете
            соблюдение авторских прав
          </p>
        </div>
        <PictureBox
          activeCategory={this.state.activeCategory}
          onRequestCloseModal={() => this.props.toggleModal(`pictures`)}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  uploader: uploaderSelector(state),
  pictures: picturesSelector(state),
  shutterStockEnabled: shutterStockEnabledSelector(state)
});

const mapDispatchToProps = {
  uploadImage,
  toggleModal,
  changeSourceUploader
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Local));
